import {
  type AuthHttpGetRegistrationsContentQuery,
  httpGetRegistrationsContent,
} from '@iconik-io/iconik-api/src/services/auth';

import promoSlides from '../../constants/promo_slides';
import {
  MANAGED_SIGNUP_PAGE_ROUTE,
  REGISTRATIONS_VERIFY_PAGE_ROUTE,
  SIGNUP_PAGE_ROUTE,
} from '../../constants/routes';
import type { AppDispatch } from '../../store/types';

export function getPromosContent(
  page_route: AuthHttpGetRegistrationsContentQuery,
) {
  const isSignupForm = [
    SIGNUP_PAGE_ROUTE,
    MANAGED_SIGNUP_PAGE_ROUTE,
    REGISTRATIONS_VERIFY_PAGE_ROUTE,
  ].includes(page_route.page_route);

  const route = isSignupForm ? 'signup' : 'login';
  return (dispatch: AppDispatch) =>
    dispatch(httpGetRegistrationsContent({ page_route: route }))
      .then(async (response) => {
        return response.body;
      })
      .catch(() => {
        // cspell:disable-next-line -- disables checking for the current line.
        // use constants to have some fallback content when request to end point fails to fetch webflow items
        return isSignupForm ? promoSlides[1] : promoSlides[0];
      });
}
